import script from "./PUR02_015INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR02_015INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR02_015INS.vue?vue&type=style&index=0&id=5351e4da&scoped=true&lang=css"
import "./PUR02_015INS.vue?vue&type=style&index=1&id=5351e4da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5351e4da"]])

export default __exports__